import { Injectable } from '@angular/core';
import { CrossSell, CrossSellOfferDetails, CrossSellStatusUpdate, NewCreditOffersEntity } from '../model/cross-sell.model';
import { Observable } from 'rxjs';
import { Communication } from '../model/communication.model';
import { ApiService } from '@workflow/ecp-shared/service/api/api.service';
import { DataLoadURL } from '@workflow/ecp-shared/model/dataload-url';
import { ApiResult } from '@workflow/ecp-workflow/dynamic-app/service/application-api/application-api.types';

@Injectable({ providedIn: 'root' })
export class CrossSellService {
  private readonly hostName = 'consumerPortalApi';
  constructor(private readonly apiService: ApiService) {}

  // Stores user custom variables enclosed in [%..%] from given text
  public targetVariables = [];

  // Stored matched custom variable from given string
  public customVariables: string[] = [];

  public GetCrossSellConfiguration(applicationid: string): Observable<ApiResult<CrossSell>> {
    const urlObj = {
      hostName: this.hostName,
      method: 'GET',
      url: `member/oao/integration/crosssell/${applicationid}`
    } as DataLoadURL;
    return this.apiService.request<ApiResult<CrossSell>>({ urlObj });
  }

  public SubmitCrossSell(objCrossSellProduct: CrossSellOfferDetails): Observable<ApiResult<CrossSellOfferDetails>> {
    const urlObj = {
      hostName: this.hostName,
      method: 'POST',
      url: 'member/oao/integration/approvecrosssell'
    } as DataLoadURL;

    return this.apiService.request<ApiResult<CrossSellOfferDetails>>({ urlObj, body: objCrossSellProduct });
  }

  public SaveCommunicationMessage(communicationObj: Communication): Observable<ApiResult<Communication>> {
    const urlObj = {
      hostName: this.hostName,
      method: 'POST',
      url: 'integration/l360/Communication/Save'
    } as DataLoadURL;

    return this.apiService.request<ApiResult<Communication>>({ urlObj, body: communicationObj });
  }

  public UpdateCrossSellInterestedStatus(
    objCrossSellProduct: CrossSellStatusUpdate,
    callback: (res: ApiResult<CrossSellOfferDetails>) => void,
    errorCallback: (err) => void
  ): void {
    const urlObj = {
      hostName: this.hostName,
      method: 'POST',
      url: 'member/oao/integration/crossSellUpdateStatus/Interested'
    } as DataLoadURL;

    this.apiService.requestApi<ApiResult<CrossSellStatusUpdate>>({
      urlObj,
      body: objCrossSellProduct,
      callback,
      errorCallback
    });
  }
  public stipulationListToDisplayHelper = (stipulations: string[]): string[] => {
    stipulations.forEach((stipulation, i) => {
      stipulations[i] = stipulation.length > 50 ? stipulation.slice(0, 50) + '...' : stipulation;
    });
    stipulations = stipulations.length > 4 ? stipulations.slice(0, 4) : stipulations;
    return stipulations;
  };

  public stipulationHelper = (stipulations: string): string[] => {
    if (stipulations) {
      return stipulations.split('|').map((item) => item.trim());
    }
    return [];
  };

  public stringReplaceCustomVar(crossSellOffer): NewCreditOffersEntity {
    if (!crossSellOffer) return;
    if (crossSellOffer.headline) crossSellOffer.headline = this.parseCustomVariable(crossSellOffer?.headline, crossSellOffer);
    if (crossSellOffer.subtitle) crossSellOffer.subtitle = this.parseCustomVariable(crossSellOffer?.subtitle, crossSellOffer);
    return crossSellOffer;
  }

  private setCustomVariableData(targetDataObject) {
    this.targetVariables = [
      { name: 'offer.loan.amount', value: targetDataObject?.decisionAmount },
      { name: 'offer.rate', value: targetDataObject?.decisionRate },
      { name: 'offer.term', value: targetDataObject?.decisionTerm },
      { name: 'offer.monthly.payment', value: targetDataObject?.estimatedPayment },
      { name: 'offer.monthly.savings', value: targetDataObject?.estimatedMonthlySavings }
    ];
  }

  private createMatchedArray(temp: string): string {
    const re = '\\[.*?\\]';
    const customVariableRegEx = new RegExp(`${re}`, 'g');
    const matchedString = temp.match(customVariableRegEx) ? temp.match(customVariableRegEx)?.toString() : '';
    if (matchedString) return matchedString;
    else return '';
  }

  public parseCustomVariable(inputString: string, targetDataObject): string {
    this.setCustomVariableData(targetDataObject);
    let tempStr = inputString;
    this.customVariables = this.createMatchedArray(inputString) ? this.createMatchedArray(inputString).split(',') : [];
    if (this.customVariables && this.customVariables.length > 0) {
      for (const customVariable of this.customVariables) {
        const str = customVariable.substring(customVariable.indexOf('[%') + 2, customVariable.indexOf('%]'));
        const replacingValue = this.targetVariables.find((x) => x.name.toLocaleLowerCase() === str.toLocaleLowerCase());
        if (replacingValue) {
          tempStr = this.replaceCustomVariables(tempStr, customVariable, replacingValue?.value);
        } else if (str === '[%') {
          tempStr = this.replaceCustomVariables(tempStr, customVariable, customVariable);
        } else {
          tempStr = this.replaceCustomVariables(tempStr, customVariable, '(ERR)');
        }
      }
    }
    return tempStr;
  }

  private replaceCustomVariables(str: string, find: string, replace: string): string {
    const replaceString = str;
    const newString = replaceString.replace(find, replace);
    return newString;
  }

  public displayStipulationOnSlideInPanel = (stipulationList: string[]): boolean => {
    if (stipulationList.length > 4) {
      return true;
    }
    return stipulationList.some((stipulation) => stipulation.length > 50);
  };
}
